import { Checkbox } from "../../../components/checkbox/checkbox";
import { FlagIcon } from "../../../assets/icons";

import { Text } from "../../../components/text/text";

import styles from "./adminCheckList.module.css"

const getDaysText = (n) => {
    if (n === 1) return "день";
    if ([11, 12, 13, 14].includes(n % 100)) return `${n} дней`;
    if (n % 10 === 1) return `${n} день`;
    if ([2, 3, 4].includes(n % 10)) return `${n} дня`;
    return `${n} дней`;
}

export const CheckListItem = ({ data, isDailyTasks }) => {
    const checked = data.countDone >= data.countTotal;

    return (
        <>
            <div className={styles.check_list_item}>
                <div className={styles.check_list_item_header}>
                    {
                        isDailyTasks &&
                        <Checkbox checked={checked} onChange={() => { }} />
                    }

                    <div className={styles.check_list_item_info}>
                        <Text as="div" variant="body" className={styles.check_list_item_name} >{data.taskText}</Text>
                        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                            {
                                (data.repeatEveryNDays !== null) &&
                                <Text as="div" variant="body" className={styles.check_list_item_subname} >{`Раз в ${getDaysText(data.repeatEveryNDays)}`}</Text>
                            }
                            {
                                !isDailyTasks && data.countTotal > 1 &&
                                <>
                                    <div className={styles.check_list_progress_target} style={{ justifyContent: "start" }}>
                                        <Text as="div" variant="body" className={styles.check_list_progress_target_text} >{data.countTotal}</Text>
                                        <FlagIcon className={styles.check_list_progress_target_icon} />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}